import { prefixObjectValues as pre } from '../../../utils';
const prefix = 'address-table';
const table = pre(
  {
    addAddressBtn: 'add-btn',
    addressRow: 'address-table-row-',
    addressTypeRow: 'address-table-type-',
    addressLine1Row: 'address-table-line1-',
    addressLine2Row: 'address-table-line2-',
    addressPostalCodeRow: 'address-table-postalCode-',
  },
  prefix
);

export default table;
